module.exports = require("./az-Cyrl");